import { useState } from 'react'
import axios from 'axios'
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  Spinner,
} from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import Logo from '../Assets/Assests/Logos/Final - logo ---Photoroom 4.png'
import Signup from '../Assets/screens/SignupVector.png'
import AiLogo1 from '../Assets/Assests/Logos/Tesla bird logo.png'
import Logo1 from '../Assets/Assests/Logos/Tesla bird logo.png'

const EnquiryForm = () => {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    donor_name: '',
    mobile_number: '',
    email_id: '',
    message: '',
  })

  const [error, setError] = useState({})
  const [loading, setLoading] = useState(false)

  const validateField = (name, value) => {
    let errors = { ...error }

    if (!value.trim()) {
      errors[name] = `${name.replace('_', ' ')} is required`
    } else {
      switch (name) {
        case 'donor_name':
          if (!/^[A-Za-z\s]{3,}$/.test(value)) {
            errors[name] =
              'Name must contain only letters and be at least 3 characters long'
          } else {
            delete errors[name]
          }
          break

        case 'email_id':
          if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(value)) {
            errors[name] = 'Enter a valid email address'
          } else {
            delete errors[name]
          }
          break

        case 'mobile_number':
          const phoneRegex = /^\+(?:[0-9] ?){6,14}[0-9]$/
          if (!phoneRegex.test(value)) {
            errors[name] =
              'Enter a valid mobile number with country code (e.g., +91 9876543210)'
          } else {
            delete errors[name]
          }
          break

        case 'message':
          if (value.trim().length < 10) {
            errors[name] = 'Message must be at least 10 characters long'
          } else {
            delete errors[name]
          }
          break

        default:
          delete errors[name]
          break
      }
    }

    setError(errors)
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
    validateField(name, value)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const newErrors = {}

    Object.keys(formData).forEach((key) => {
      validateField(key, formData[key])
    })

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors)
      return
    }

    setLoading(true)

    try {
      const payload = {
        name: formData.donor_name,
        mobile_number: formData.mobile_number,
        email: formData.email_id,
        note: formData.message,
      }

      const response = await axios.post(
        'https://aimuseumbackend.teslabird.com/membership/enquiry/',
        payload
      )

      if (response.status === 201 || response.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Enquiry Submitted',
          text: 'We will get back to you soon!',
          confirmButtonText: 'OK',
          confirmButtonColor: '#002740',
        })
        navigate('/')
      }
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Submission Failed',
        text: 'Unable to send your enquiry. Please try again later.',
        confirmButtonText: 'Retry',
        confirmButtonColor: '#002740',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Container fluid className='min-vh-100 d-flex'>
      <Row className='w-100'>
        {/* Left Side Illustration */}
        <Col
          md={6}
          className='d-none d-md-flex flex-column align-items-center justify-content-center text-white'
          style={{ backgroundColor: '#DDEEFC' }}
        >
          <div
            className='d-flex align-items-center'
            style={{ position: 'absolute', top: '0', left: '0' }}
          >
            <a href='/'>
              <img
                src={AiLogo1}
                alt='Museum Logo'
                width={80}
                height={80}
                style={{
                  marginRight: '20px',
                  marginLeft: '20px',
                  marginTop: '15px',
                }}
              />
            </a>
          </div>
          <img
            src={Signup}
            alt='Illustration'
            className='img-fluid'
            style={{ maxWidth: '350px', marginTop: '100px' }}
          />
        </Col>

        {/* Form Side */}
        <Col
          xs={12}
          md={6}
          className='d-flex flex-column align-items-center justify-content-center p-4'
        >
          <a href='/'>
            <img
              src={Logo1}
              alt='Logo'
              className='img-fluid d-block d-md-none mb-3'
              style={{ width: '120px' }}
            />
          </a>

          <Card
            className='shadow-lg rounded-4 p-4 w-100'
            style={{ maxWidth: '400px', maxHeight: '100vh' }}
          >
            <Card.Body>
              <h2 className='fw-bold mb-3'>Enquiry Form</h2>

              {Object.keys(error).length > 0 && (
                <Alert variant='danger'>
                  {Object.values(error).map((err, idx) => (
                    <div key={idx}>{err}</div>
                  ))}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                {[
                  { label: 'Full Name', name: 'donor_name', type: 'text' },
                  { label: 'Contact No.', name: 'mobile_number', type: 'text' },
                  { label: 'Email', name: 'email_id', type: 'email' },
                ].map((field, idx) => (
                  <Form.Group className='mb-3' key={idx}>
                    <Form.Label className='text-muted small'>
                      {field.label}
                    </Form.Label>
                    <Form.Control
                      type={field.type}
                      name={field.name}
                      placeholder={`Enter ${field.label.toLowerCase()}`}
                      value={formData[field.name]}
                      onChange={handleChange}
                      className='border-0 border-bottom'
                      style={{ color: 'black' }}
                      isInvalid={!!error[field.name]}
                    />
                    <Form.Control.Feedback type='invalid'>
                      {error[field.name]}
                    </Form.Control.Feedback>
                  </Form.Group>
                ))}

                <Form.Group className='mb-3'>
                  <Form.Label className='text-muted small'>Message</Form.Label>
                  <Form.Control
                    as='textarea'
                    name='message'
                    placeholder='Write your message here'
                    value={formData.message}
                    onChange={handleChange}
                    rows={2}
                    className='border-0 border-bottom'
                    style={{ color: 'black' }}
                    isInvalid={!!error.message}
                  />
                  <Form.Control.Feedback type='invalid'>
                    {error.message}
                  </Form.Control.Feedback>
                </Form.Group>

                <Button
                  type='submit'
                  className='w-100 text-white rounded-pill'
                  style={{ backgroundColor: '#002740' }}
                  disabled={loading}
                >
                  {loading ? (
                    <Spinner animation='border' size='sm' />
                  ) : (
                    'Submit'
                  )}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default EnquiryForm
